/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _callSlick = __webpack_require__(1);
	
	var _callSlick2 = _interopRequireDefault(_callSlick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	$(function () {
	  // iosか判別
	  var isIOS = /iP(hone|(o|a)d)/.test(navigator.userAgent);
	
	  // iosの場合とその他の場合でアプリのリンクを出し分ける
	  $('.js-spLink').on('click', function (e) {
	    var link = '';
	
	    if (isIOS) {
	      link = $(e.currentTarget).data('iosLink');
	    } else {
	      link = $(e.currentTarget).data('androidLink');
	    }
	    location.href = link;
	  });
	
	  // コンテンツがスクロール内に入ったら吹き出しを出す
	  $('.js-animationTrigger').one('inview', function (e) {
	    $(e.currentTarget).find('.js-animationTarget').addClass('is-active');
	  });
	
	  new _callSlick2.default({ breakpoint: 600 });
	}); // import visibilityObserver from './_modules/_visibilityObserver';

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Slick.jsをお呼びする
	 */
	var CallSlick = function () {
	  function CallSlick(options) {
	    _classCallCheck(this, CallSlick);
	
	    this.options = options;
	    this.$slick = $('.js-Slick');
	    this.slickOptions = {
	      default: {
	        autoplay: true,
	        autoplaySpeed: 1500,
	        arrows: false,
	        centerMode: false,
	        infinite: true,
	        variableWidth: true,
	        dots: false,
	        mobileFirst: false,
	        speed: 500,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        centerPadding: 0,
	        swipe: false,
	        responsive: [{
	          breakpoint: 600,
	          settings: 'unslick'
	        }]
	      }
	    };
	    this.init();
	  }
	
	  _createClass(CallSlick, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      if (this.$slick[0]) {
	        this.$slick.each(function (idx, el) {
	          var $this = $(el);
	          var myOptions = $this.data('slick-options') ? _this.slickOptions[$this.data('slick-options')] : _this.slickOptions.default;
	          var slick = new _this.setSlick($this, myOptions);
	        });
	      }
	    }
	  }, {
	    key: 'setSlick',
	    value: function setSlick($this, options) {
	      $this.slick(options);
	    }
	  }]);
	
	  return CallSlick;
	}();
	
	exports.default = CallSlick;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.js